function cleanPath(path) {
	if (path[0] == '/')
		return path.substring(1);
	else
		return path
}
function pluralForm ( n, forms ) {
	return forms[(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2) ];
}
function getCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}
function setCookie(name, value, options) {
	options = options || {};

	var expires = options.expires;

	if (typeof expires == "number" && expires) {
		var d = new Date();
		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}
	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	var updatedCookie = name + "=" + value;

	for (var propName in options) {
		updatedCookie += "; " + propName;
		var propValue = options[propName];
		if (propValue !== true) {
			updatedCookie += "=" + propValue;
		}
	}

	document.cookie = updatedCookie;
}
function deleteCookie(name) {
	setCookie(name, "", {
		expires: -1
	})
}
(function(dom, utils, config){

	utils.delayRender = function(callback){
		return setTimeout(callback, config.renderDelay);
	};

	utils.delayDuration = function(callback){
		return setTimeout(callback, config.duration);
	};

	utils.prevent = function(e){
		e.preventDefault();
	};

	//-полная блокировака скролла страницы
	utils.pageScroll = {};
	utils.pageScroll.disable = function(){
		dom.$document.on('touchmove', function(event){
			event.preventDefault();
		});
		dom.$window.on('mousewheel', function(event){
			event.preventDefault();
		});
	};
	utils.pageScroll.enable = function(){
		dom.$document.off('touchmove');
		dom.$window.off('mousewheel');
	};

	//- привязка скролла к определенной позиции
	utils.scrollLock = function(pos) {
		dom.$window.bind('scroll',function () {
			dom.$window.scrollTop(pos);
		});
	};
	utils.scrollUnlock = function() {
		dom.$window.unbind('scroll');
	};

	utils.footerToBottom = function ($target) {
		var $targetBox = $target || dom.$footer.prev('.box');

		$targetBox.css('min-height', '');

		var heightContent = dom.$footer.offset().top + dom.$footer.outerHeight(true),
			dif = app.sizes.height - heightContent;

		if (dif > 0) $targetBox.css('min-height', $targetBox.outerHeight() + (app.sizes.height - heightContent));
	};


	// меню
	var pos; // текущая позиция скролла

	utils.menuOpen = function() {
		var $topMenu = $('.topMenu');

		$topMenu.removeClass('main');
		$topMenu.removeClass('close').addClass('open');

		if (app.sizes.width < app.mobileTo) {
			pos = $(window).scrollTop(); // текущая позиция скролла

			setTimeout(function(){
				$('html, body').addClass('overflow--menu');
			}, 500);
		}
	};
	utils.menuClose = function() {
		var $topMenu = $('.topMenu');

		$topMenu.removeClass('open').addClass('close');

		if (app.sizes.width < app.mobileTo) { // for mobile
			$('html, body').removeClass('overflow--menu');
			$(window).scrollTop(pos); // возвращаем скролл
			$topMenu.scrollTop(0);
		}
	};


	utils.slidePreview = function(slider, preview){
		var $slider = $(slider),
			$nextBg = $slider.find('.swiper-button-next .swiper-button-bg'),
			$prevBg = $slider.find('.swiper-button-prev .swiper-button-bg'),
			indexCur = $slider.find('.swiper-slide-active').index(),
			bgNext = $slider.find('.swiper-slide').eq(indexCur + preview).attr('data-bg'), // .data() не работает, хз почему
			bgPrev = $slider.find('.swiper-slide').eq(indexCur - 1).attr('data-bg'),
			isMobile = function() {
				if (app.sizes.width > app.mobileTo) {
					if (bgNext) {
						$nextBg.css({'background-image': 'url("' + bgNext + '")'});
					};
					if (bgPrev) {
						$prevBg.css({'background-image': 'url("' + bgPrev + '")'});
					};
				}
			};

			isMobile();

			app.dom.$window.resize(function() {
				isMobile();
			});
	};

	utils.swiper = function(slider, count, effect, callback, actionBlock) {
		new Swiper($(slider).find('.swiper-container'), {
			keyboardControl: true,
			updateOnImagesReady: true,
			slidesPerView: count,
			effect: effect,
			// autoplay: 4000,
			nextButton: $(slider).find('.swiper-button-next'),
			prevButton: $(slider).find('.swiper-button-prev'),
			onInit: function(){
				if (callback) utils.slidePreview(slider, count);
				if (actionBlock) {
					var $box = $('.blockActions'),
						width = $(slider).find('.swiper-slide').width(),
						heightBox = $box.height();

					if (width <= heightBox) $box.find('.blockActions__right').height(width);
					else {
						if (app.sizes.width < app.mobileTo) {
							$box.find('.blockActions__right').height(width);
						}
					}
				}
			},
			onSlideChangeEnd: function(){
				if (callback) utils.slidePreview(slider, count);
			},
			breakpoints: {
				1020: {
					slidesPerView: 1
				}
			}
		});
	};


	utils.tooltip = function(tooltip, rootElement) {
		var $rootElement = $(rootElement),
			$item = null,
			pageHeight = $('.page').outerHeight(),
			pageWidth = $rootElement.outerWidth(),
			$gotoMap = tooltip.find('.js-gotoMap');

		$rootElement.on('mouseenter', '.blockList__item', function() {
			tooltip.stop().fadeIn(100, function(){
				app.dom.$content.addClass('over');
			});
			$(this).addClass('active');
			$item = $(this);
		});

		$rootElement.on('mouseleave', '.blockList__item', function(event) {
			// если mouseleave, то relatedTarget - элемент, на который перешел курсор
			if(!$(event.relatedTarget).hasClass('tooltip'))
				$(this).removeClass('active');

			// если mouseleave, то target - элемент, с которого ушел курсор, то есть на котором возникло событие
			if(!$(event.target).hasClass('active'))
				tooltip.stop().fadeOut(100, function(){
				app.dom.$content.removeClass('over');
			});
		});

		tooltip.on('mouseenter', function() {
			tooltip.stop().fadeIn(100, function(){
				app.dom.$content.addClass('over');
			});
		});

		tooltip.on('mouseleave', function() {
			$item.removeClass('active');
			tooltip.stop().fadeOut(100, function(){
				app.dom.$content.removeClass('over');
			});
		});

		tooltip.on('mousewheel', function(event) {
			event.stopPropagation();
		});

		// координаты относительно элемента
		$rootElement.on('mousemove', '.blockList__item', function() {
			var itemTopPos = $(this).offset().top,
				itemLeftPos = $(this).offset().left,
				x = pageHeight - itemTopPos,
				y = pageWidth - itemLeftPos,
				tooltipHeight = tooltip.outerHeight(),
				tooltipWidth = tooltip.outerWidth();

			if ((x > tooltipHeight) && (y > tooltipWidth) ) { // true, когда все ок
				tooltip.css({
					left: $(this).offset().left + $(this).outerWidth(),
					top: $(this).offset().top
				});
			} else {
				if ((y < tooltipWidth) && (x > tooltipHeight)) { // true, когда tooltip по ширине не помещается в блоке
					tooltip.css({
						left: $(this).offset().left - $(this).outerWidth() - ($(this).outerWidth()/2.5),
						top: $(this).offset().top
					});
				} else if ((y > tooltipWidth) && (x < tooltipHeight)) { // true, когда tooltip по высоте не помещается на экране
					tooltip.css({
						left: $(this).offset().left + $(this).outerWidth(),
						top: $(this).offset().top + $(this).outerHeight() - tooltipHeight
					});
				} else { // true, когда и по ширине и по высоте не помещается
					tooltip.css({
						left: $(this).offset().left - $(this).outerWidth() - ($(this).outerWidth()/2.5),
						top: $(this).offset().top + $(this).outerHeight() - tooltipHeight
					});
				}
			}
		});
	};

	utils.scroller = function($scroller, $prev, $next, $box) {

		var isMobile = function() {
			if (app.sizes.width < app.mobileTo) {

				$scroller.mCustomScrollbar({
					axis: 'y'
				});

			} else {
				var pos = 0;

				$scroller.mCustomScrollbar({
					axis: 'x',
					snapAmount: 0.00001,
					callbacks: {
						onInit: function(el) {
							$prev.addClass('swiper-button-disabled');
						},
						whileScrolling: function() {
							$prev.addClass('swiper-button-disabled');
							$next.addClass('swiper-button-disabled');
						},
						onScroll: function() {
							position(this);
							$prev.removeClass('swiper-button-disabled');
							$next.removeClass('swiper-button-disabled');
						},
						onOverflowXNone: function() {
							$prev.addClass('swiper-button-disabled');
							$next.addClass('swiper-button-disabled');
						},
						onTotalScroll: function(){
							$next.addClass('swiper-button-disabled');
						},
						onTotalScrollBack: function(){
							$prev.addClass('swiper-button-disabled');
						}
					}
				});

				$next.on('click', function(event) {

					$scroller.mCustomScrollbar('scrollTo', pos - 1000, {
						scrollInertia: 1000,
						callbacks: true
					});
				});

				$prev.on('click', function(event) {

					if (pos > -1000) {
						pos = 0;
					} else pos = pos + 1000;

					$scroller.mCustomScrollbar('scrollTo', pos, {
						scrollInertia: 1000,
						callbacks: true
					});
				});

				function position(el) {
					pos = el.mcs.left;
				}
			}
		};

		$scroller.mCustomScrollbar('destroy');

		isMobile();

		app.dom.$window.on('resize', function() {
			isMobile();
		});
		$scroller.on('mousewheel', function(event) {
			event.stopPropagation();
		});
	};
})(app.dom, app.utils, app.config);
